import { useGetDetailWhatsGoingOnQuery, useUpdateWhatsGoingOnMutation } from "store/whatsgoingon";
import WhatsGoingOnForm, { initialWgo } from "pages/whatsgoingon/form/form";
import type { ErrorProps } from "modules/types";
import Notification from "components/notification";
import GLOBAL from "modules/global";

export default function Edit(props: {
  id: number | null;
  open: boolean;
  onClose: () => void;
}) {
  const { id, open, onClose } = props;

  const { data: detailData, isFetching } = useGetDetailWhatsGoingOnQuery(id || 0, {
    skip: !open || !id
  });

  const [update, updateResult] = useUpdateWhatsGoingOnMutation();

  function handleSubmit(formData: FormData) {
    update(formData);
  }

  const initialValues = detailData;

  if (!open || isFetching) return null;

  return (
    <>
      <WhatsGoingOnForm
        open={open}
        onClose={onClose}
        loading={updateResult.isLoading}
        fetching={isFetching}
        initialValues={{
          ...initialValues,
          campaignContent: initialValues?.campaignContent?.length ? initialValues.campaignContent : initialWgo.campaignContent
        }}
        onSubmit={handleSubmit}
      />
      <Notification
        open={!updateResult.isLoading && !updateResult.isUninitialized}
        onClose={() => (updateResult.isError ? updateResult.reset() : location.reload())}
        isError={Boolean(updateResult.error) && updateResult.isError}
        message={GLOBAL.returnExceptionMessage(updateResult.isError, updateResult.error as ErrorProps)}
      />
    </>
  );
}